export default __webpack_public_path__ + "static/media/car1.30445100.jpeg";